import type { IInheritedClauseGuidance } from "@/api";
import { cn } from "@/lib/utils";
import { inheritedGuidanceLabel } from "@/utils/inheritedGuidanceLabel";
import { useId } from "react";

interface IProps {
    /**
     * The guidance inherited from the organization that shares it
     */
    inherited: IInheritedClauseGuidance;
    /**
     * Whether the organization's own guidance replaces the inherited guidance
     */
    replaced: boolean;
}

/**
 * Shows the guidance a clause inherits and whether it is in use
 */
export const InheritedGuidanceBlock = ({ inherited, replaced }: IProps) => {
    const labelId = useId();

    return (
        <section aria-labelledby={labelId} className="flex flex-col gap-2">
            <p id={labelId} className="text-sm font-medium wrap-anywhere">
                {inheritedGuidanceLabel(inherited.shared_by_organization_name)}
            </p>
            <div className="bg-muted/50 rounded px-5 py-3">
                <p
                    className={cn(
                        "text-left text-sm wrap-anywhere",
                        replaced ? "text-muted-foreground" : "text-foreground"
                    )}
                >
                    "{inherited.guidance}"
                </p>
            </div>
            <p className="text-muted-foreground text-xs">
                {replaced
                    ? "Your organization's custom guidance replaces this."
                    : "Used until your organization adds custom guidance."}
            </p>
        </section>
    );
};
